import React, { Component } from "react";
import { BLOCKS, MARKS, INLINES } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import DOMPurify from "isomorphic-dompurify";
import "./RichtextRender.scss"

export class RichTextRenderer extends Component {
  options = {
    renderMark: {
      [MARKS.BOLD]: (text) => <strong>{text}</strong>,
      [MARKS.ITALIC]: (text) => <em>{text}</em>,
    },
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <p className="p-description">{children}</p>
      ),
      [BLOCKS.HEADING_1]: (_node, children) => <h1>{children}</h1>,
      [BLOCKS.HEADING_2]: (_node, children) => <h2>{children}</h2>,
      [BLOCKS.HEADING_5]: (_node, children) => <h2 className="e-effort-header-text">{children}</h2>,
      [BLOCKS.UL_LIST]: (_node, children) => <ul>{children}</ul>,
      [BLOCKS.OL_LIST]: (_node, children) => <ol>{children}</ol>,
      [BLOCKS.LIST_ITEM]: (_node, children) => <li>{children}</li>,
      [INLINES.HYPERLINK]: (node, children) => (
        <a
          href={DOMPurify.sanitize(node.data.uri)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {children}
        </a>
      ),
      
      // wrote a custom one to identify the tables
      ['table']: (_node, children) => (
        <table className="contentful-table">
          <tbody>{children}</tbody>
        </table>
      ),
      ['table-row']: (_node, children,key) =>{
        return <tr>{children}</tr>;
      },
      ['table-cell']: (node, children) => <td>{children}</td>,
      ['table-header-cell']: (node, children) => <th>{children}</th>,
    },
  };

  render() {
    const { document } = this.props;
    return <div>{documentToReactComponents(document, this.options)}</div>;
  }
}